import { animated, useSpring } from '@react-spring/web';

import { Paragraph } from '@app/shared/ui/atoms/Common';
import { SlideContainer, SlideHeading } from '@app/shared/ui/atoms/DailyEnergy';
import {
  MOON_IMAGE_SPRING_CONFIGS_MAP,
  DESCRIPTION_SPRING_CONFIGS_MAP,
} from '@app/shared/constants/dailyEnergy';

interface SlideThreeContentProps {
  moonImgSrc: string;
  moonPhaseName: string;
  moonPhaseDescription: string;
}

export function SlideThreeContent({
  moonImgSrc,
  moonPhaseName,
  moonPhaseDescription,
}: SlideThreeContentProps) {
  const moonImageSprings = useSpring({ ...MOON_IMAGE_SPRING_CONFIGS_MAP[3] });
  const descriptionSprings = useSpring({ ...DESCRIPTION_SPRING_CONFIGS_MAP[3] });

  return (
    <SlideContainer className="mb-[140px]">
      <animated.img
        style={moonImageSprings}
        src={moonImgSrc}
        alt="moon"
        className="mx-auto w-[185px]"
      />

      <animated.div style={descriptionSprings} className="flex flex-col gap-4">
        <SlideHeading>{moonPhaseName}</SlideHeading>

        <Paragraph variant="white" className="font-normal">
          {moonPhaseDescription}
        </Paragraph>
      </animated.div>
    </SlideContainer>
  );
}
